import { cn } from '../../classname';
import './sticky.css';
const b = cn('editor-sticky');
export const stickyCn = {
    toolbar: ({ withSettings, stickyActive, isSticky }, mix) => {
        const mods = {
            part: withSettings ? 'left' : false,
            'sticky-active': stickyActive,
            sticky: isSticky,
        };
        return b(mods, mix);
    },
    settings: ({ withToolbar, stickyActive }, mix) => {
        const mods = {
            part: withToolbar ? 'right' : false,
            'sticky-active': stickyActive,
            clear: !withToolbar,
            sticky: true,
        };
        return b(mods, mix);
    },
};
